import React from 'react';
import { FaStar } from 'react-icons/fa';

const STAR_VALUES = [1, 2, 3, 4, 5];

/**
 * @param {{ value: number, onChange?: (n: number) => void, readOnly?: boolean, size?: 'sm' | 'md' }} props
 */
export function ComplaintStarRating({ value = 0, onChange, readOnly = false, size = 'md' }) {
  const filled = Math.max(0, Math.min(5, Math.round(Number(value) || 0)));
  const iconClass = size === 'sm' ? 'h-4 w-4' : 'h-6 w-6';

  return (
    <div
      className="inline-flex items-center gap-0.5"
      role={readOnly ? 'img' : 'group'}
      aria-label={readOnly ? `${filled} out of 5 stars` : 'Rate from 1 to 5 stars'}
    >
      {STAR_VALUES.map((star) => {
        const active = star <= filled;
        const common = `${iconClass} ${active ? 'text-amber-400' : 'text-gray-300'}`;
        if (readOnly) {
          return (
            <FaStar
              key={star}
              className={common}
              aria-hidden
            />
          );
        }
        return (
          <button
            key={star}
            type="button"
            className="rounded p-0.5 transition hover:scale-110 focus:outline-none focus:ring-2 focus:ring-amber-300"
            aria-label={`${star} star${star === 1 ? '' : 's'}`}
            onClick={() => onChange?.(star)}
          >
            <FaStar className={common} />
          </button>
        );
      })}
    </div>
  );
}
